import Enumeration from '../../../../../../foundation/enumeration/Enumeration';

export default class CourseVisibility extends Enumeration {

	public static readonly ORGANIZATION = 'ORGANIZATION';
	public static readonly PRIVATE = 'PRIVATE';
	public static readonly PUBLIC = 'PUBLIC';

	public static organization () { return new this(this.ORGANIZATION); }
	public static private () { return new this(this.PRIVATE); }
	public static public () { return new this(this.PUBLIC); }

	public isOrganization () { return this.is(CourseVisibility.ORGANIZATION); }
	public isPrivate () { return this.is(CourseVisibility.PRIVATE); }
	public isPublic () { return this.is(CourseVisibility.PUBLIC); }

	protected getPossibleValues () {
		return [CourseVisibility.ORGANIZATION, CourseVisibility.PRIVATE, CourseVisibility.PUBLIC];
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/aggregates/course/CourseVisibility.ts